import type { APIOptions } from "@sieg-ad/fetch";

export const loader = async <T>(api: any, query: APIOptions<T>['query'], loading?: Ref<boolean>): Promise<T[]> => {
  if (loading) loading.value = true;
  try {
    if (!api) throw new Error("API is not defined");
    if (!query) throw new Error("Query is not defined");

    const { data } = await api.find({ query });
    return data ?? [];
  }
  catch (error) {
    console.error('Erro ao carregar dados:', error);
    return [];
  }
  finally {
    if (loading) loading.value = false;
  }
};
